/**
 * @description 判断是否是预发环境
 * @returns boolean
 */
const isBeta = (): boolean => /-beta\d+\.duitang\.com/.test(window.location.host);

export default isBeta;
